export function yearsAndMonths(
  totalMonths: number,
  full: boolean = false,
): string {
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;
  if (years === 0) {
    return `${months} month${months === 1 ? "" : "s"}`;
  }
  if (months === 0) {
    return `${years} year${years === 1 ? "" : "s"}`;
  }
  if (full) {
    return `${years} year${years === 1 ? "" : "s"} and ${months} month${months === 1 ? "" : "s"}`;
  }
  return `${years} yrs ${months} mos`;
}
